// About.js
import React, { Component } from 'react';
import DenseTable from './WorkBountyTable'

class WorkBounty extends Component {




  render() {
    return (
    <div className="container">
    <h2>Welcome to SPPhotonic WorkBounty</h2>
	<DenseTable/>

    <h3>© SPPhotonic Inc 2021</h3>
    </div>
    );
  }
}

export default WorkBounty;